import Navbar from "landingPage/components/navbar_v2";
import Footer from "landingPage/components/footer_v2";
import queryString from "query-string";
import { FormatCurrency, } from "../../../../util"
import { AlertError, AlertSuccess } from "../../../../component"
import { decrypt } from "../../../../service"
import { useState } from "react"
import axios from "axios"
import Cookies from "js-cookie"

const baseURL = process.env.REACT_APP_URL_CLIENT_LANDING;

const PaymentConfirmationSection = () => {
  const { total_bill, order_code } = queryString.parse(window.location.search);
  const [img, setImg] = useState("")
  const token = Cookies.get("token") ? decrypt(Cookies.get("token")) : ""

  const btnSubmit = async () => {
    const formData = new FormData();

    formData.append("payment_image", img)
    formData.append("order_code", order_code)

    // for (var pair of formData.entries()) {
    //   console.log(pair[0] + ', ' + pair[1]);
    // }

    const { data } = await axios.post(`${baseURL}/order/upload_payment`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": `Bearer ${token}`
      }
    })

    if (data.message) {
      AlertSuccess({ title: "Success", text: data.message, timer: 5000 })
    }

    console.log({ data })
  }
  return (
    <div>
      <Navbar />
      <div className="container mt-4">
        <h1 className="text-center">Payment Confirmation</h1>

        <div className="container-info-payment mt-2 w-100 d-flex justify-content-center flex-column align-items-center">
          <table className=" w-50">
            <tbody>
              <tr>
                <td className=" w-50">
                  <strong> Order ID</strong>
                </td>
                <td>: {order_code || "-"}</td>
              </tr>
              <tr>
                <td>
                  <strong> Total Of Payment</strong>
                </td>
                <td>:  {FormatCurrency.currency(total_bill || 0)}</td>
              </tr>
              <tr>
                <td>
                  <strong> Proof Of Payment</strong>
                </td>
                <td className=" d-flex">
                  :
                  <input
                    accept=".png,.jpg,.jpeg"
                    type="file"
                    name=""
                    id=""
                    className="form-control"
                    onChange={e => setImg(e.target.files)}
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <div className="mb-2 mt-2 w-50">
            <button className="btn button-primary" style={{ width: "100%" }} onClick={btnSubmit}>
              Submit Confirmation
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PaymentConfirmationSection;
